var map = {
	"./1-blik-info.png": "10a4",
	"./Przelewy-24.png": "31a8",
	"./Przelewy24_logo.png": "d867",
	"./ap-logo.png": "b52b",
	"./ap-logo1.png": "2ae6",
	"./bg1.jpg": "9970",
	"./bg1.png": "72dd",
	"./bg2.jpg": "101e",
	"./blik.png": "a1e4",
	"./blik.svg": "8bbb",
	"./blik_v1.png": "6a90",
	"./blik_v2.png": "f35c",
	"./email-blue.svg": "bb25",
	"./email-white.svg": "c42a",
	"./email.svg": "7711",
	"./flags/en.jpg": "e462",
	"./flags/en.svg": "ebb2",
	"./heart-grey.png": "4ce5",
	"./logo-ap.svg": "b412",
	"./logo_lubie_ludzi.png": "2b11",
	"./logo_short_szp.png": "75bf",
	"./mastercard.png": "3c3e",
	"./przelewy24_logo_2022_grey.svg": "fb78",
	"./przelewy24_logo_2022_navy_blue.svg": "98ef",
	"./przelewy_24_white_lekkie.png": "50f4",
	"./safe-payment-icon-grey.svg": "55c8",
	"./safe-payment-icon-navy-blue.svg": "afaf",
	"./sp-logo.png": "ec48",
	"./stripe-grey.svg": "291a",
	"./stripe-navy-blue.svg": "9813",
	"./summary_background_AP.jpg": "b612",
	"./summary_background_AP_mobile_portrait.jpg": "b68b",
	"./summary_background_SZP.jpg": "2f5c",
	"./summary_background_SZP_mobile.jpg": "3ad3",
	"./summary_background_SZP_mobile_portrait.jpg": "9131",
	"./szp-logo-2022.png": "465e",
	"./szp-logo-2023.png": "44f5",
	"./visa-mobile-info.png": "eea1",
	"./visa-mobile-info_x1.png": "08c3",
	"./visa-mobile-info_x2.png": "d4cf",
	"./visa-mobile-info_x3.png": "9241",
	"./visa-mobile-info_x4.png": "7fe6",
	"./visa.png": "a236",
	"./zdjecie_podziekowanie.png": "bed4",
	"./zdjecie_podziekowanie_mobile.jpg": "9f56"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";